import { StanFilters } from '@/components';
import { FILTER_CONFIGS } from '../constants/appointmentData';
import type { StanFilterConfig, StanFilterValue } from '@/components/core-components/StanFilters/types';

interface AppointmentsFiltersProps {
    filterValues: StanFilterValue[];
    onFilterChanged: (filters: StanFilterValue[]) => void;
    onResetFilters: () => void;
}

export function AppointmentsFilters({ filterValues, onFilterChanged, onResetFilters }: AppointmentsFiltersProps) {
    const filters: StanFilterConfig[] = FILTER_CONFIGS;

    return (
        <StanFilters
            filters={filters}
            filterValues={filterValues}
            onFilterChanged={onFilterChanged}
            onResetFilters={onResetFilters}
        />
    );
}
